import React from 'react';
import { cn } from './cn';

/**
 * Toolbar — two-column bar above a table.
 *   <Toolbar
 *     left={<><SearchInput/><FilterSelect/></>}
 *     right={<><DensityToggle/><ExportButton/></>}
 *   />
 */
export function Toolbar({ left, right, className }) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-2 mb-3',
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">{left}</div>
      {right && <div className="flex shrink-0 items-center gap-2">{right}</div>}
    </div>
  );
}

export default Toolbar;
